
import { useState } from "react";
import { Separator } from "@/components/ui/separator";
import { AccountSheet } from "./AccountSheet";
import { SidebarHeader } from "./sidebar/SidebarHeader";
import { SidebarNav } from "./sidebar/SidebarNav";
import { PlanUsageCard } from "./sidebar/PlanUsageCard";
import { UserMenu } from "./sidebar/UserMenu";

const Sidebar = () => {
  const [isAccountOpen, setIsAccountOpen] = useState(false);

  return (
    <>
      <aside className="w-64 min-h-screen bg-white border-r border-gray-100 fixed flex flex-col z-20">
        <SidebarHeader />
        <SidebarNav />
        
        <div className="px-3 pb-6 space-y-4">
          <PlanUsageCard />
          <Separator />
          <UserMenu />
        </div>
      </aside>

      <AccountSheet 
        open={isAccountOpen}
        onOpenChange={setIsAccountOpen}
      />
    </>
  );
};

export default Sidebar;
